import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import store from './store'

import { Message } from 'element-ui'

let Base64 = require('js-base64').Base64

Vue.use(Router, VueCookies, axios)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/Index',
      name: 'Index',
      component: () => import('./views/Index/index.vue'),
      meta: {
        title: '供水管网微信端首页'
      }
    },
    {
      path: '/dataInside',
      name: 'dataInside',
      component: () => import('./views/DataInside/DataInside.vue'),
      meta: {
        title: '数据录入'
      }
    },
    {
      path: '/warningCheck',
      name: 'warningCheck',
      component: () => import('./views/warningCheck/warningCheck.vue'),
      meta: {
        title: '警报查看'
      }
    },
    {
      path: '/warningMakesure',
      name: 'warningMakesure',
      component: () => import('./views/warningMakesure/warningMakesure.vue'),
      meta: {
        title: '警报确认'
      }
    },
    {
      path: '/recordCheck',
      name: 'recordCheck',
      component: () => import('./views/RecordCheck/RecordCheck.vue'),
      meta: {
        title: '查询历史手抄数据'
      }
    },
    {
      path: '/pressCheck',
      name: 'pressCheck',
      component: () => import('./views/PressCheck/PressCheck.vue'),
      meta: {
        title: '查询线上爬取数据'
      }
    },
    {
      path: '/flowCheck',
      name: 'flowCheck',
      component: () => import('./views/FlowCheck/FlowCheck.vue'),
      meta: {
        title: '查询爬取西江数据'
      }
    },
    {
      path: '/xjCheck',
      name: 'xjCheck',
      component: () => import('./views/xjCheck/xjCheck.vue'),
      meta: {
        title: '查询三水调度数据'
      }
    },
    {
      path: '/electricityCheck',
      name: 'electricityCheck',
      component: () => import('./views/electricityCheck/electricityCheck.vue'),
      meta: {
        title: '查询爬取丹灶数据'
      }
    },
    {
      path: '/salesCheck',
      name: 'salesCheck',
      component: () => import('./views/SalesCheck/SalesCheck.vue'),
      meta: {
        title: '查询产销差'
      }
    },
    {
      path: '/details',
      name: 'details',
      component: () => import('./views/Details/Details'),
      meta: {
        // keepAlive: true,
        title: '警报详情'
      },
    },
    {
      path: '/warningdetails',
      name: 'warningdetails',
      component: () => import('./views/warningDetails/warningDetails'),
      meta: {
        // keepAlive: true,
        title: '警报详情'
      },
    },
    {
      path: '/monitorvalue',
      name: 'monitorvalue',
      component: () => import('./views/monitorValue/monitorValue'),
      meta: {
        // keepAlive: true,
        title: '警报详情'
      },
    },
    {
      path: '/latestData',
      name: 'latestData',
      component: () => import('./views/latestData/latestData'),
      meta: {
        // keepAlive: true,
        title: '最新调度数据'
      },
    },
    {
      path: '/inspectionList',
      name: 'inspectionList',
      component: () => import('./views/InspectionRecord/inspectionRecord'),
      meta: {
        // keepAlive: true,
        title: '管网巡查情况'
      },
    },
    {
      path: '/inspectionRecord',
      name: 'inspectionRecord',
      component: () => import('./views/InspectionRecord/Details'),
      meta: {
        // keepAlive: true,
        title: '管网巡查情况详情'
      },
    },
    {
      path: '/keyInspectionList',
      name: 'keyInspectionList',
      component: () => import('./views/KeyInspectionRecord/keyInspectionRecord'),
      meta: {
        // keepAlive: true,
        title: '警报详情'
      },
    },
    {
      path: '/keyInspectionRecord',
      name: 'keyInspectionRecord',
      component: () => import('./views/KeyInspectionRecord/Details'),
      meta: {
        // keepAlive: true,
        title: '警报详情'
      },
    },
  ],
  // 路由跳转没有回到顶部的问题
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 通过url的token来注册
  let token = sessionStorage.getItem('wxtoken') || ''
  // 如果session和query都没有token，需要去授权
  if (token == '' && !to.query.token) {
    // 去授权
    let url =
      process.env.VUE_APP_AUTHORIZEURL +
      escape('https://scwaternetwork.fsxjgs.com' + to.fullPath)
    // window.location.href = process.env.VUE_APP_AUTHORIZEURL + uri
    window.location.replace(url)
  } else {
    if (token) {
      // 说明已经有了token，可以直接过去了
      if (to.name === 'deviceinfo' && !to.query.token) {
        window.location.href =
          process.env.VUE_APP_URL + to.fullPath + '&token=' + token
      } else {
        next()
      }
    } else {
      // 说明第一次进来，session中没有token
      token = to.query.token
      if (!token || !/\S/.test(token)) {
        Message({
          message: '用户未注册或未激活（没有token）',
          type: 'error'
        })
      } else {
        // 第一次拿着token进来要做的事情
        let userIdToken = token.slice(
          token.indexOf('.') + 1,
          token.lastIndexOf('.')
        )
        // 拿到userId和roleList
        let data = JSON.parse(Base64.decode(userIdToken))
        let userId = data.sub
        let roleList = data.roleList.split(',')
        let areaId = data.areaId

        sessionStorage.setItem('wxtoken', token, 30 * 60)
        sessionStorage.setItem('userId', userId)
        sessionStorage.setItem('roleList', JSON.stringify(roleList))
        sessionStorage.setItem('areaId', areaId)
        store.dispatch('changeCurRoleList', roleList)
        next()
      }
    }
  }
})

export default router
